import Vue from 'vue';

function showHelp (text) {
  Vue.prototype.$dialog.confirm({ text, actions: { ok: { text: 'OK', flat: false, outlined: true, color: 'grey' } } });
}

export default function (key) {
  switch (key) {
    case 'DUPLICATION_DERNIERE_COMMANDE':
      return showHelp('La duplication de dernière commande ne peut pas être utilisée pour l’ensemble des articles.<br/><br/>Pour commander des aliments à destination des volailles, il est nécessaire d’utiliser le menu “plan d’alimentation”.<br/><br/>La liste des articles commandables sur le site est disponible dans le menu “aliments”.');
  }
};
